import EventsTracking from '../../../../shared/eventsTracking';

export default {
  mounted() {
    const { taggingId } = this;

    this.tracking = new EventsTracking(taggingId);
  },
};
